module.exports = __webpack_public_path__ + "img/start-mini-2.aa530cd0.jpg";